import { render, staticRenderFns } from "./CallsWidgetContent.vue?vue&type=template&id=672e990a&scoped=true"
import script from "./CallsWidgetContent.vue?vue&type=script&lang=js"
export * from "./CallsWidgetContent.vue?vue&type=script&lang=js"
import style0 from "./CallsWidgetContent.vue?vue&type=style&index=0&id=672e990a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672e990a",
  null
  
)

export default component.exports